import React from 'react';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import RouteHeader from '../RouteHeader/routeHeader';
import Card from '../../../Helper/CardWrapper/cardWrapper';
import ContentGrid from '../../../Helper/gridWrapper/gridWrapper';
import VisitorsTable from '../Visitors/visitorsTable';
import ActivityTable from '../Activity/activityTable';
import OverViewApp from './overviewAppView';
import './Overview.css';
import Chart from './Chart';
import { getUserAction } from '../../../Actions/index';
import ChartHeader from './chartHeader';
import {routeName} from '../../../../src/Service/env';
import AppWrapper from '../../../Helper/AppWrapper/appWrapper';
import {getAppointment} from "../../../Actions/appointmentAction";
import {getOrder} from "../../../Actions/orderAction";
import moment from "moment";

const styles={
    button: {
        padding: 0,
        fontSize: '1em',
        minWidth: '88px',
        color: '#A435A6'
    },
    table: {
        minWidth: 200,
    },
    headLine:{
        fontWeight: 500,
        fontSize:16
    }
};

class Overview extends React.Component {
  constructor(){
    super();
    this.state={
      deal:0,
      checkIn:0,
      user:{},
      callOverview:false
    }
  }
  componentDidMount(){
        this.props.getUserAction().then((data)=>{
        this.setState({user:data,callOverview:true})
      });

      // var Return_Device;
      // if(/(up.browser|up.link|mmp|symbian|smartphone|midp|wap|phone|android|iemobile|w3c|acs\-|alav|alca|amoi|audi|avan|benq|bird|blac|blaz|brew|cell|cldc|cmd\-|dang|doco|eric|hipt|inno|ipaq|java|jigs|kddi|keji|leno|lg\-c|lg\-d|lg\-g|lge\-|maui|maxo|midp|mits|mmef|mobi|mot\-|moto|mwbp|nec\-|newt|noki|palm|pana|pant|phil|play|port|prox|qwap|sage|sams|sany|sch\-|sec\-|send|seri|sgh\-|shar|sie\-|siem|smal|smar|sony|sph\-|symb|t\-mo|teli|tim\-|tosh|tsm\-|upg1|upsi|vk\-v|voda|wap\-|wapa|wapi|wapp|wapr|webc|winw|winw|xda|xda\-) /i.test(navigator.userAgent))
      // {
      //     if(/(tablet|ipad|playbook)|(android(?!.*(mobi|opera mini)))/i.test(navigator.userAgent))
      //     {
      //         Return_Device = 'Tablet';
      //     }
      //     else
      //     {
      //         Return_Device = 'Mobile';
      //     }
      // }
      // else if(/(tablet|ipad|playbook)|(android(?!.*(mobi|opera mini)))/i.test(navigator.userAgent))
      // {
      //     Return_Device = 'Tablet';
      // }
      // else
      // {
      //     Return_Device = 'Desktop';
      // }

      let isIOS = /iPad|iPhone|iPod/.test(navigator.platform)  || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

      if (!isIOS) {
          if (!Notification.requestPermission()) {
              return true;
          }

          Notification.requestPermission().then(function (result) {
              if (result === 'denied') {
                  console.log('denied', result);
                  return;
              }
              if (result === 'granted') {
                  console.log('allow', result);
              }
          });

          Notification.requestPermission().then(function (permission) {
              // If the user accepts, let's create a notification
              if (permission === "granted") {
              }
          });
      }

      setTimeout(() => {
          const userId = localStorage.getItem('UserId')
          if (userId !== "") {
              const appointmentCount = localStorage.getItem('appointmentCount');
              if ((appointmentCount === null || appointmentCount === "" || appointmentCount === 'undefined' || appointmentCount === '0') && (this.props.user.results.BusinessUser.AppointmentFormId !== "" && this.props.user.results.BusinessUser.AppointmentFormId !== null)) {
                  this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.results.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000`);
              }

              const orderCount = localStorage.getItem('orderCount');
              if ((orderCount === null || orderCount === "" || orderCount === 'undefined' || orderCount === '0') && (this.props.user.results.BusinessUser.OnlineOrderFormId !== "" && this.props.user.results.BusinessUser.OnlineOrderFormId !== null)) {
                  this.getOrders()
              }

              // if(this.props && !this.props.IsAppointmentTimerSet){
              // var IsAppointmentTimerSet = true
              window.interval = setInterval(() => {
                  if ((this.props.user.results.BusinessUser.AppointmentFormId !== "" && this.props.user.results.BusinessUser.AppointmentFormId !== null)) {
                      this.props.getAppointment(`https://api.jotform.com/form/${this.props.user.results.BusinessUser.AppointmentFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000`);
                  }

                  if ((this.props.user.results.BusinessUser.OnlineOrderFormId !== "" && this.props.user.results.BusinessUser.OnlineOrderFormId !== null && !window.location.pathname.includes('Order'))) {
                      this.getOrders()
                  }
                  }, 60000
              );
              // }
          }
      }, 1000);
  }

  getOrders() {
      if (this.props.user.results.BusinessUser.OnlineOrderFormType === "jotform") {
          // let strStartDate =  moment().subtract(30,'days').format('MM/DD/YYYY')
          // let strEndDate = moment().add(1, 'days').format('MM/DD/YYYY')
          let strStartDate =  moment().subtract(6,'days').format('MM/DD/YYYY')
          let strEndDate = moment().add(1, 'days').format('MM/DD/YYYY')

          this.props.getOrder(this.props.user.results.BusinessUser.OnlineOrderFormType, `https://api.jotform.com/form/${this.props.user.results.BusinessUser.OnlineOrderFormId}/submissions?apiKey=09ec9741da1cb60e6cf174b550577672&limit=1000&filter={"created_at:gt":"${strStartDate}","created_at:lt":"${strEndDate}"}`);
      } else {
          // let startDat =  moment().subtract(30,'days').format('MM-DD-YYYY HH:mm:ss')
          // let endDat =  moment().add(1, 'days').format('MM-DD-YYYY HH:mm:ss')
          let startDat =  moment().subtract(7,'days').format('MM-DD-YYYY HH:mm:ss')
          let endDat =  moment().add(1, 'days').format('MM-DD-YYYY HH:mm:ss')
          let utcStartDat = moment(startDat,'MM-DD-YYYY HH:mm:ss').utc().format('MM-DD-YYYY')
          let utcEndDat = moment(endDat,'MM-DD-YYYY HH:mm:ss').utc().format('MM-DD-YYYY')
          this.props.getOrder(this.props.user.results.BusinessUser.OnlineOrderFormType,`/GrabWordpressOrdersWithPagination/${this.props.user.results.BusinessUser.OnlineOrderFormId}/'All'/1/40/'${utcStartDat}'/'${utcEndDat}'`);
      }
  }

  showAllVisitors=()=>{
    this.props.history.push(`/${routeName}/Dashboard/Visitors`)
  };
  calculate=(deal,checkIn)=>{
      this.setState({deal,checkIn});
  };

  showAllActivity=()=>{
      this.props.history.push(`/${routeName}/Dashboard/Activity`)
  };

  render(){
      const { classes,visitors,activity } = this.props;
      const {user,callOverview}=this.state;
      return(
          <div className='container-div'>
            <div>
              {callOverview && <ContentGrid
                header={
                  user.results.BusinessUser.IsFirstVisit && JSON.parse(user.results.BusinessUser.IsFirstVisit)['Overview'] ?
                    <RouteHeader title={'Overview'}
                                 text={'is a place where you can see all your progress, latest updates, as well as how your profile looks like on the app.'}
                                 onClick={this.hideHeader}
                    /> : <span/>
                }
                content={
                  <Grid container spacing={24}>
                    <Grid item sm={12} xs={12}>
                      <section>
                        <Card header={<ChartHeader deal={this.state.deal} className="overview-graph-space"
                                                   checkIn={this.state.checkIn}/>}
                              content={<Chart dataCount={this.calculate}/>} CardContentProps={{
                          style: {minHeight: '13vh'}
                        }}/>
                      </section>
                    </Grid>
                    <Grid item sm={6} xs={12} className="tablePadding">
                      <Card
                        header={'Most Frequent Visitors'}
                        CardHeaderProps={{
                          classes: {
                            title: classes.headLine
                          }
                        }}
                        content={
                          <VisitorsTable size={5}/>
                        }
                        CardContentProps={{
                          style: {minHeight: '44vh', padding: 0, borderTop: '1px solid #ddd'}
                        }}
                        actions={
                          visitors.results.Result.length > 0 &&
                          <Button color={'primary'}
                                  className={classes.button}
                                  onClick={this.showAllVisitors}
                          >
                            See All Visitors
                          </Button>
                        }

                      />
                    </Grid>
                    <Grid item sm={6} xs={12} className="tablePadding">
                      <Card
                        header={'Recent Activity'}
                        CardHeaderProps={{
                          classes: {
                            title: classes.headLine
                          }
                        }}
                        content={
                          <ActivityTable size={6}/>
                        }
                        CardContentProps={{
                          style: {minHeight: '44vh', padding: 0, borderTop: '1px solid #ddd'}
                        }}
                        actions={
                          activity.results.BusinessActivity.length > 0 &&
                          <Button
                            color={'primary'}
                            className={classes.button}
                            onClick={this.showAllActivity}
                          >
                            See All Activity
                          </Button>
                        }
                      />
                    </Grid>
                  </Grid>
                }
                appView={
                  <AppWrapper tab={1} header={
                    <div>{this.props.user.results.AppUser.FirstName} Profile</div>
                  }
                              content={<OverViewApp/>}/>
                }
              />}
            </div>
            <div>
              <div style={{width:"70%"}} />
             <div className="verified-text">
               <div><img src={require(`../../../images/chek.png`)} className="verified-logo"/></div>
               <div className="verified-text-down">{'Verified logo builds trust and lets your customers know that you are a real business.'}</div>
               </div>
            </div>
          </div>
    )
  }
}
const mapStateToProps=(state)=> {
    return {
        user:state.loginResponse,
        activity:state.activity,
        visitors:state.visitors,
        messageData: state.messageReducer,
        appointment:state.appointmentReducer.appointment,
        order:state.orderReducer.order
    }
};
const matchDispatchToProps=(dispatch)=> {
  return bindActionCreators({
      getUserAction,
      getAppointment,
      getOrder
  },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(Overview));